import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {NgModel} from '@angular/forms';
import {LiveAnnouncer} from '@angular/cdk/a11y';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'si-validation-error-text',
  templateUrl: './validation-error-text.component.html',
  styleUrls: ['./validation-error-text.component.scss']
})
export class ValidationErrorTextComponent implements OnChanges {
  @Input() text: string;
  @Input() textWarning: string;
  @Input() formModel: NgModel;

  constructor(
    private liveAnnouncer: LiveAnnouncer,
    private translateService: TranslateService
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.text && !changes.text.firstChange && this.text) {
      this.liveAnnouncer.announce(this.translateService.instant(this.text), 'assertive');
    }

    if (changes.textWarning && !changes.textWarning.firstChange && this.textWarning) {
      this.liveAnnouncer.announce(this.translateService.instant(this.textWarning), 'assertive');
    }
  }
}
